import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
} from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterLink } from '@angular/router';
import {
  HELP_CONTENT,
  HelpEntry,
} from 'app/core/constants/help-file-url.component';
import { HelpMenuData } from 'app/core/models/help-centre/help-centre';
import { MenuService } from 'app/core/services/menu/menu.service';
import { PersonDetailNavbarComponent } from 'app/ui/person-detail-navbar/person-detail-navbar.component';
import { HelpDialogComponent } from '../help-dialog/help-dialog.component';

@Component({
  selector: 'sqep-header',
  imports: [
    RouterLink,
    MatIconModule,
    MatIconButton,
    MatToolbarModule,
    PersonDetailNavbarComponent,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent {
  readonly navbarBgClass = input<string>();
  readonly clientLogoAsset = input<string>();
  readonly helpEntry = input<HelpEntry>(HELP_CONTENT.Default);
  readonly toggle = output();
  private readonly dialog = inject(MatDialog);
  private readonly homeMenu = inject(MenuService);

  setHomeMenu() {
    this.homeMenu.selectHomeMenu(true);
  }

  openHelp(): void {
    const entry = this.helpEntry();
    this.dialog.open(HelpDialogComponent, {
      width: '400px',
      position: { top: '64px', right: '16px' },
      data: {
        pageContext: entry.description,
        guideSlug: entry.slug,
        guideName: entry.guideName,
        whatsNewSlug: 'whats-new',
        supportUrl:
          'https://support.sqeptech.com/_hcms/mem/login?redirect_url=https%3A%2f%2fsupport.sqeptech.com%2ftickets-view%3Foffset%3D0',
      } satisfies HelpMenuData,
    });
  }
}
